import { type FC, type ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import { getByDocCreator } from '../../shared/getByDocCreator';
import {
    useItemTranslations,
    INTERFACE_STATE,
} from '../PdpSharedOriginalLanguageProvider/PdpSharedOriginalLanguageProvider';
import cn from 'classnames';

import { type PdpRespTitle_item$key } from './__generated__/PdpRespTitle_item.graphql';

import styles from './PdpRespTitle.scss';

type Props = {
    item: PdpRespTitle_item$key;
    isPDPDesktopAggregationVariant?: boolean;
    isSoldPDPV3Variant?: boolean | null;
};

export const PdpRespTitle: FC<Props> = ({
    item: itemRef,
    isPDPDesktopAggregationVariant,
    isSoldPDPV3Variant,
}) => {
    const item = useFragment(
        graphql`
            fragment PdpRespTitle_item on Item {
                title
                isArt
                classification {
                    creationDate
                }
                ...getByDocCreator_item
            }
        `,
        itemRef
    );
    const { isArt, title, classification } = item || {};

    let artCreator = null;
    let artCreationDate = null;
    const [state] = useItemTranslations();
    let itemTitle: string | ReactNode =
        state?.interfaceState === INTERFACE_STATE.SHOW_ORIGINAL
            ? state?.data?.viewer?.item?.title
            : title;

    if (isArt) {
        itemTitle = (
            <span className={styles.artTitle} data-tn="pdp-item-title">
                {itemTitle}
            </span>
        );

        const creationDate = classification?.creationDate;
        if (creationDate) {
            artCreationDate = (
                <p className={styles.artCreationDate} data-tn="pdp-item-creation-date">
                    {creationDate}
                </p>
            );
        }

        artCreator = getByDocCreator({ item });
    }

    return (
        <h1
            className={cn(styles.wrapper, {
                [styles.isPDPDesktopAggregationVariant]: isPDPDesktopAggregationVariant,
                [styles.isSoldPDPV3Variant]: isSoldPDPV3Variant,
            })}
            data-tn="pdp-resp-title"
        >
            {artCreator}
            <div data-tn="pdp-main-title">
                {itemTitle}
                {artCreationDate}
            </div>
        </h1>
    );
};
